export const COLOUR_COMPONENT_FLATTENED = 2;
export const OAE_SIDEBAR_MIN_COMPONENTS = 3;

// Routes
export const ROUTE_PREVIEW = 'preview';
export const ROUTE_ASSISTANT = 'assistant';
export const PREVIEW_FPO_MAX = 500;
